import { Component, OnInit } from '@angular/core';
import { SeoService } from 'src/app/services/seo.service';

@Component({
  selector: 'v2m-blog-export',
  templateUrl: './blog-export.component.html',
  styleUrls: ['./blog-export.component.scss']
})
export class BlogExportComponent implements OnInit {
  constructor(private seo: SeoService) {}

  ngOnInit() {
    this.seo.updateTitle('video2manual - Export');
    this.seo.updateKeywords('FAQ,Export,Durchlaufender Film,Youtube');
  }
}
